"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6384,2494],{

/***/ 73238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "aG": function() { return /* binding */ Breadcrumb; },
/* harmony export */   "gN": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* unused harmony exports BreadcrumbSeparator, useBreadcrumbStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34031);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54520);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28387);
// ../../../react-shim.js


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");

// src/breadcrumb.tsx




// src/breadcrumb-context.ts

var [BreadcrumbStylesProvider, useBreadcrumbStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `BreadcrumbStylesContext`,
  errorMessage: `useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Breadcrumb />" `
});

// src/breadcrumb.tsx
var Breadcrumb = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Breadcrumb2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Breadcrumb", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const {
    children,
    spacing = "0.5rem",
    separator = "/",
    className,
    listProps,
    ...rest
  } = ownProps;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__/* .getValidChildren */ .W)(children);
  const count = validChildren.length;
  const clones = validChildren.map((child, index) => (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
    separator,
    spacing,
    isLastChild: count === index + 1
  }));
  const _className = cx("chakra-breadcrumb", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.nav */ .m$.nav, {
    ref,
    "aria-label": "breadcrumb",
    className: _className,
    __css: styles.container,
    ...rest
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.ol */ .m$.ol, {
    className: "chakra-breadcrumb__list",
    ...listProps,
    __css: {
      display: "flex",
      alignItems: "center",
      ...styles.list
    }
  }, clones)));
});
Breadcrumb.displayName = "Breadcrumb";

// src/breadcrumb-item.tsx



// src/breadcrumb-separator.tsx

var BreadcrumbSeparator = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbSeparator2(props, ref) {
  const { spacing, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const separatorStyles = {
    mx: spacing,
    ...styles.separator
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    role: "presentation",
    ...rest,
    __css: separatorStyles
  });
});
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";

// src/breadcrumb-link.tsx

var BreadcrumbLink = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbLink2(props, ref) {
  const { isCurrentPage, as, className, href, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const sharedProps = {
    ref,
    as,
    className: cx("chakra-breadcrumb__link", className),
    ...rest
  };
  if (isCurrentPage) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
      "aria-current": "page",
      __css: styles.link,
      ...sharedProps
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.a */ .m$.a, {
    __css: styles.link,
    href,
    ...sharedProps
  });
});
BreadcrumbLink.displayName = "BreadcrumbLink";

// src/breadcrumb-item.tsx

var BreadcrumbItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbItem2(props, ref) {
  const {
    isCurrentPage,
    separator,
    isLastChild,
    spacing,
    children,
    className,
    ...rest
  } = props;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__/* .getValidChildren */ .W)(children);
  const clones = validChildren.map((child) => {
    if (child.type === BreadcrumbLink) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        isCurrentPage
      });
    }
    if (child.type === BreadcrumbSeparator) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        spacing,
        children: child.props.children || separator
      });
    }
    return child;
  });
  const styles = useBreadcrumbStyles();
  const itemStyles = {
    display: "inline-flex",
    alignItems: "center",
    ...styles.item
  };
  const _className = cx("chakra-breadcrumb__list-item", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.li */ .m$.li, {
    ref,
    className: _className,
    ...rest,
    __css: itemStyles
  }, clones, !isLastChild && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbSeparator, {
    spacing
  }, separator));
});
BreadcrumbItem.displayName = "BreadcrumbItem";



/***/ }),

/***/ 46384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73238);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3382);
/* harmony import */ var src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60316);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








var Breadcrumbs = function Breadcrumbs(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_1__/* .Breadcrumb */ .aG, {
      breadcrumbData: items
    }), items && items.length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
      as: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kq,
      p: "l",
      alignContent: "left",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Breadcrumb */ .aG, {
        fontFamily: "Montserrat-Medium",
        fontSize: ".875rem",
        color: "baseDark",
        letterSpacing: ".2px",
        lineHeight: "18px",
        textAlign: "left",
        separator: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_5__/* .ChevronRightIcon */ .XC, {
          color: "baseDark"
        }),
        children: items.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .BreadcrumbItem */ .gN, {
            children: item.href ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .BreadcrumbLink */ .At, {
              isCurrentPage: index === items.length - 1,
              href: item.href,
              title: item.title,
              color: index !== items.length - 1 ? 'baseDark' : 'baseNeutral.700',
              _hover: {
                textDecoration: 'none',
                color: 'baseNeutral.700'
              },
              children: item.page
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
              children: item.title
            })
          }, item.page);
        })
      })
    }) : null]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Breadcrumbs);

/***/ }),

/***/ 60316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aG": function() { return /* reexport */ StructuredData_Breadcrumb; },
  "By": function() { return /* reexport */ StructuredData_Faq; },
  "TR": function() { return /* reexport */ StructuredData_Logo; },
  "dc": function() { return /* reexport */ StructuredData_NltOffer; },
  "_6": function() { return /* reexport */ StructuredData_OfferList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/containers/data/brands.json
var brands = __webpack_require__(11669);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/NltOffer.tsx





var NltOffer = function NltOffer(_ref) {
  var offerData = _ref.offerData;
  var data = {
    "@context": "https://schema.org/",
    "@type": "Vehicle",
    "name": "".concat(offerData.vehicle.name, " - Noleggio a Lungo Termine"),
    "image": offerData.images.map(function (image) {
      return image.src;
    }),
    "description": "".concat(offerData.vehicle.name, " a ").concat(offerData.monthlyRate, "\u20AC al mese! Con CarPlanner hai manutenzione, assicurazione, bollo, tassa di propriet\xE0 a molti altri servizi, inclusi in un unico canone mensile."),
    "sku": offerData.code,
    "mpn": offerData.id,
    "fuelType": offerData.vehicle.engine.fuel,
    "brand": {
      "@type": "Brand",
      "name": offerData.vehicle.brand,
      "logo": brands.find(function (brand) {
        return brand.href === offerData.vehicle.brandCode;
      }).image
    },
    "offers": {
      "@type": "Offer",
      "url": "https://www.carplanner.com/noleggio-a-lungo-termine/".concat(offerData.vehicle.brandCode, "/").concat(offerData.vehicle.modelCode, "/").concat(offerData.code),
      "priceCurrency": 'EUR',
      "price": offerData.monthlyRate,
      "itemCondition": 'https://schema.org/NewCondition',
      "availability": 'https://schema.org/LimitedAvailability',
      "seller": {
        '@type': 'Organization',
        "name": "CarPlanner",
        "url": "https://www.carplanner.com/",
        "logo": "https://static1.carplanner.com/logos/carplanner.svg"
      }
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataNltOffer",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_NltOffer = (NltOffer);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Logo.tsx




var Logo = function Logo() {
  var data = {
    "@context": "https://schema.org/",
    "@type": "Organization",
    "name": "Noleggio a Lungo Termine",
    "url": "https://www.carplanner.com/",
    "logo": "https://static1.carplanner.com/logos/carplanner.svg"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataLogo",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Logo = (Logo);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./server/api/nlt.ts
var nlt = __webpack_require__(27449);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Faq.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Faq = function Faq() {
  var _useState = (0,react.useState)([]),
      faqSingleItems = _useState[0],
      setFaqSingleItems = _useState[1];

  (0,react.useEffect)(function () {
    function getFaqs() {
      return _getFaqs.apply(this, arguments);
    }

    function _getFaqs() {
      _getFaqs = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var faqs;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,nlt/* getFaqAutoCompleteItems */.eF)();

              case 2:
                faqs = _context.sent;
                setFaqSingleItems(faqs.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getFaqs.apply(this, arguments);
    }

    if (!faqSingleItems.length) {
      getFaqs();
    }
  });
  var faqItems = {};
  faqSingleItems.forEach(function (faqItem) {
    faqItems[faqItem.uri] = faqItems[faqItem.uri] || [];
    faqItems[faqItem.uri].push(_objectSpread({}, faqItem));
  });
  var data = {
    "@context": "https://schema.org/",
    "@type": "FAQPage",
    "mainEntity": Object.keys(faqItems).map(function (faqUri) {
      return {
        "@type": "Question",
        "url": "https://www.carplanner.com/noleggio-a-lungo-termine/faq/".concat(faqUri),
        "name": faqItems[faqUri][0].title,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faqItems[faqUri].map(function (faqItem) {
            return "<p><strong>".concat(faqItem.q || '', "</strong> ").concat(faqItem.a || '', "</p>");
          }).join('')
        }
      };
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataFaq",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Faq = (Faq);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Breadcrumb.tsx




var Breadcrumb = function Breadcrumb(_ref) {
  var breadcrumbData = _ref.breadcrumbData;
  var data = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbData.map(function (crumbItem, idx) {
      return {
        "@type": "ListItem",
        "position": idx + 1,
        "name": crumbItem.title,
        "item": "https://carplanner.com".concat(crumbItem.href)
      };
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataBreadcrumb",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Breadcrumb = (Breadcrumb);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/OfferList.tsx




var OfferList = function OfferList(_ref) {
  var items = _ref.items;
  var data = {
    "@context": "https://schema.org/",
    "@type": "ItemList",
    "numberOfItems": items.length,
    "itemListElement": items.map(function (item, idx) {
      return {
        "@type": "ListItem",
        "position": idx,
        "url": item
      };
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataOfferList",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_OfferList = (OfferList);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/index.ts






/***/ }),

/***/ 11669:
/***/ (function(module) {

module.exports = JSON.parse('[{"href":"alfa-romeo","image":"https://static1.carplanner.com/cars/brands/alfa-romeo.svg","name":"Alfa Romeo","slug":"ALF"},{"href":"abarth","image":"https://static1.carplanner.com/cars/brands/abarth.svg","name":"Abarth","slug":"ABA"},{"href":"aston-martin","image":"https://static1.carplanner.com/cars/brands/aston-martin.svg","name":"Aston Martin","slug":"AST"},{"href":"audi","image":"https://static1.carplanner.com/cars/brands/audi.svg","name":"Audi","slug":"AUD"},{"href":"bentley","image":"https://static1.carplanner.com/cars/brands/bentley.svg","name":"Bentley","slug":"BEN"},{"href":"bmw","image":"https://static1.carplanner.com/cars/brands/bmw.svg","name":"BMW","slug":"BMW"},{"href":"byd","image":"https://static1.carplanner.com/cars/brands/byd.svg","name":"BYD","slug":"BYD"},{"href":"cadillac","image":"https://static1.carplanner.com/cars/brands/cadillac.svg","name":"Cadillac","slug":"CAD"},{"href":"chevrolet","image":"https://static1.carplanner.com/cars/brands/chevrolet.svg","name":"Chevrolet","slug":"CHC"},{"href":"chrysler","image":"https://static1.carplanner.com/cars/brands/chrysler.svg","name":"Chrysler","slug":"CHR"},{"href":"citroen","image":"https://static1.carplanner.com/cars/brands/citroen.svg","name":"Citroen","slug":"CIT"},{"href":"cupra","image":"https://static1.carplanner.com/cars/brands/cupra.svg","name":"Cupra","slug":"CUP"},{"href":"dacia","image":"https://static1.carplanner.com/cars/brands/dacia.svg","name":"Dacia","slug":"DAC"},{"href":"dr","image":"https://static1.carplanner.com/cars/brands/dr.svg","name":"DR","slug":"DRM"},{"href":"ds","image":"https://static1.carplanner.com/cars/brands/ds.svg","name":"DS","slug":"DSA"},{"href":"ferrari","image":"https://static1.carplanner.com/cars/brands/ferrari.svg","name":"Ferrari","slug":"FER"},{"href":"fiat","image":"https://static1.carplanner.com/cars/brands/fiat.svg","name":"Fiat","slug":"FIA"},{"href":"ford","image":"https://static1.carplanner.com/cars/brands/ford.svg","name":"Ford","slug":"FOR"},{"href":"honda","image":"https://static1.carplanner.com/cars/brands/honda.svg","name":"Honda","slug":"HON"},{"href":"hyundai","image":"https://static1.carplanner.com/cars/brands/hyundai.svg","name":"Hyundai","slug":"HYU"},{"href":"infiniti","image":"https://static1.carplanner.com/cars/brands/infiniti.svg","name":"Infiniti","slug":"INF"},{"href":"jaguar","image":"https://static1.carplanner.com/cars/brands/jaguar.svg","name":"Jaguar","slug":"JAG"},{"href":"jaecoo","image":"https://static1.carplanner.com/cars/brands/jaecoo.svg","name":"Jaecoo","slug":"JAE"},{"href":"jeep","image":"https://static1.carplanner.com/cars/brands/jeep.svg","name":"Jeep","slug":"JEE"},{"href":"kia","image":"https://static1.carplanner.com/cars/brands/kia.svg","name":"Kia","slug":"KIA"},{"href":"lamborghini","image":"https://static1.carplanner.com/cars/brands/lamborghini.svg","name":"Lamborghini","slug":"LAM"},{"href":"lancia","image":"https://static1.carplanner.com/cars/brands/lancia.svg","name":"Lancia","slug":"LAN"},{"href":"land-rover","image":"https://static1.carplanner.com/cars/brands/land-rover.svg","name":"Land Rover","slug":"LND"},{"href":"leapmotor","image":"https://static1.carplanner.com/cars/brands/leapmotor.svg","name":"Leap Motor","slug":"LEA"},{"href":"lexus","image":"https://static1.carplanner.com/cars/brands/lexus.svg","name":"Lexus","slug":"LEX"},{"href":"lotus","image":"https://static1.carplanner.com/cars/brands/lotus.svg","name":"Lotus","slug":"LOT"},{"href":"mahindra","image":"https://static1.carplanner.com/cars/brands/mahindra.svg","name":"Mahindra","slug":"MAH"},{"href":"maserati","image":"https://static1.carplanner.com/cars/brands/maserati.svg","name":"Maserati","slug":"MAS"},{"href":"mazda","image":"https://static1.carplanner.com/cars/brands/mazda.svg","name":"Mazda","slug":"MAZ"},{"href":"mclaren","image":"https://static1.carplanner.com/cars/brands/mclaren.svg","name":"McLaren","slug":"MCL"},{"href":"mercedes","image":"https://static1.carplanner.com/cars/brands/mercedes.svg","name":"Mercedes-Benz","slug":"MER"},{"href":"mg","image":"https://static1.carplanner.com/cars/brands/mg.svg","name":"MG","slug":"MGG"},{"href":"mini","image":"https://static1.carplanner.com/cars/brands/mini.svg","name":"Mini","slug":"MIN"},{"href":"mitsubishi","image":"https://static1.carplanner.com/cars/brands/mitsubishi.svg","name":"Mitsubishi","slug":"MIT"},{"href":"nissan","image":"https://static1.carplanner.com/cars/brands/nissan.svg","name":"Nissan","slug":"NIS"},{"href":"omoda","image":"https://static1.carplanner.com/cars/brands/omoda.svg","name":"Omoda","slug":"OMO"},{"href":"opel","image":"https://static1.carplanner.com/cars/brands/opel.svg","name":"Opel","slug":"OPE"},{"href":"peugeot","image":"https://static1.carplanner.com/cars/brands/peugeot.svg","name":"Peugeot","slug":"PEU"},{"href":"porsche","image":"https://static1.carplanner.com/cars/brands/porsche.svg","name":"Porsche","slug":"POR"},{"href":"renault","image":"https://static1.carplanner.com/cars/brands/renault.svg","name":"Renault","slug":"REN"},{"href":"rolls-royce","image":"https://static1.carplanner.com/cars/brands/rolls-royce.svg","name":"Rolls-Royce","slug":"ROL"},{"href":"seat","image":"https://static1.carplanner.com/cars/brands/seat.svg","name":"Seat","slug":"SEA"},{"href":"skoda","image":"https://static1.carplanner.com/cars/brands/skoda.svg","name":"Skoda","slug":"SKO"},{"href":"smart","image":"https://static1.carplanner.com/cars/brands/smart.svg","name":"Smart","slug":"SMA"},{"href":"ssangyong","image":"https://static1.carplanner.com/cars/brands/ssangyong.svg","name":"Ssangyong","slug":"SAN"},{"href":"subaru","image":"https://static1.carplanner.com/cars/brands/subaru.svg","name":"Subaru","slug":"SUB"},{"href":"suzuki","image":"https://static1.carplanner.com/cars/brands/suzuki.svg","name":"Suzuki","slug":"SUZ"},{"href":"tesla","image":"https://static1.carplanner.com/cars/brands/tesla.svg","name":"Tesla","slug":"TES"},{"href":"toyota","image":"https://static1.carplanner.com/cars/brands/toyota.svg","name":"Toyota","slug":"TOY"},{"href":"volkswagen","image":"https://static1.carplanner.com/cars/brands/volkswagen.svg","name":"Volkswagen","slug":"VLK"},{"href":"volvo","image":"https://static1.carplanner.com/cars/brands/volvo.svg","name":"Volvo","slug":"VOL"}]');

/***/ })

}]);